import { render, staticRenderFns } from "./OkrAddForm.vue?vue&type=template&id=34cc098d&scoped=true&"
import script from "./OkrAddForm.vue?vue&type=script&lang=js&"
export * from "./OkrAddForm.vue?vue&type=script&lang=js&"
import style0 from "./OkrAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OkrAddForm.vue?vue&type=style&index=1&id=34cc098d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cc098d",
  null
  
)

export default component.exports